import AccountCircle from "@mui/icons-material/AccountCircle";
export function UserIcon() {
  return <AccountCircle />;
}
